export const heapUtil = {
  track: (event: string, metadata?: object) => {
    if (window.heap) {
      window.heap.track(event, metadata);
    }
  }
};
